import React from 'react';
import { dayjs } from '@lba-dev/package.local-globals/dayjs';
import { paymentMethods } from '@lba-dev/package.local-globals/getDataById';

import CollapsedTwoColumnList from
  '../../components/List/CollapsedTwoColumnList';

export const formatBoolean = (bool) => {
  if (bool !== undefined) {
    return bool ? 'Oui' : 'Non';
  }
  return undefined;
};

export const formatPrice = (price) => {
  if (price !== undefined) {
    return `${(price / 100).toFixed(2)} €`;
  }
  return undefined;
};

export const formatDate = (date, hour = true) =>
  date && dayjs(date).format(hour ? 'L [à] HH:mm' : 'L');

export const formatPaymentMethod = (paymentMethod) =>
  paymentMethods[paymentMethod].fullName;

export const formatProducts = (products) =>
  products &&
  products.map(({ ref, name, desc, pa, pu, qt }) => (
    <CollapsedTwoColumnList
      key={ref}
      title={`#${ref}`}
      data={{
        Nom: name,
        Description: desc,
        'Prix annoncé': formatPrice(pa),
        'Prix unitaire': formatPrice(pu),
        Quantité: qt,
      }}
    />
  ));

export const formatSupplies = (supplies) =>
  supplies &&
  supplies.map(
    ({ bl, montant, pro, qt, suppliesDate, suppliesName, ut, validate }) => (
      <CollapsedTwoColumnList
        key={`${suppliesName}-${montant}`}
        title={suppliesName}
        data={{
          'Ajouté par': suppliesDate,
          BL: bl,
          'Prix unitaire': formatPrice(ut),
          Montant: formatPrice(montant),
          Fournisseur: pro,
          Quantité: qt,
          Validée: formatBoolean(validate),
        }}
      />
    )
  );
